export function App() {
  return <>Hotel LFAR Root</>;
}
